
import { Project } from '../types';

export const hiveKeywordSearch: Project = {
  id: 'hive-keyword-search',
  title: 'Hive Keyword Search',
  description: 'A powerful tool to search and filter keywords across the Hive blockchain history.',
  longDescription: 'Hive Keyword Search allows users to dive deep into the blockchain history to find specific mentions, trends, and discussions. It leverages specialized indexing to provide fast, relevant results for any keyword or author. Perfect for researchers and community managers.',
  image: 'https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/louis88/48a2r6GhENwfVXpfH1nKQuP1LeXXDk1YhrdCehAjuMtBePrPBB19zhxLkfKQ3ri2SX.png',
  tags: ['Search', 'Indexing', 'React', 'Dhive'],
  link: 'https://keywordsearch.vercel.app', // Defaulting to Github if live link unknown
  github: 'https://github.com/louis-88/Hive-Keyword-Search',
  announcementUrl: 'https://peakd.com/hive-139531/@louis88/hivekeywordsfetcher-search-posts-on-hive-by-mentioned-words',
  featured: true
};
